import React from "react";
import { siteBlogPosts } from "../../config/blogs";
import BlogPostCard from "../BlogSection/BlogPostCard";

const RelatedBlog: React.FC = () => {
  return (
    <div className="related-blog pt-130">
      <h2 className="related-blog-title">Browse related blog</h2>

      <div className="row mt-none-30">
        {siteBlogPosts.map((post) => (
          <div className="col-lg-4 col-md-6 mt-30" key={post.id}>
            <BlogPostCard post={post} small />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedBlog;
